import clsx from 'clsx';
import React, { forwardRef } from 'react';

type TextAreaProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  maxLength?: number;
  rows?: number;
  className?: string;
  wrapperClassName?: string;
  onFocus?: React.FocusEventHandler<HTMLTextAreaElement>;
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
  textAreaRef?: React.RefObject<HTMLTextAreaElement>;
};

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      value,
      onChange,
      placeholder,
      disabled = false,
      autoFocus = false,
      maxLength,
      rows = 4,
      className,
      wrapperClassName,
      onFocus,
      onBlur,
      textAreaRef,
    },
    ref
  ) => {
    const textAreaRefToUse = textAreaRef || ref;

    return (
      <div className={clsx('w-full rounded-lg bg-[#F4F4F4] px-4 py-3', wrapperClassName)}>
        <textarea
          ref={textAreaRefToUse}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          autoFocus={autoFocus}
          maxLength={maxLength}
          rows={rows}
          className={clsx(
            'w-full resize-y border-none bg-transparent text-sm font-medium outline-none',
            value ? 'text-black' : 'text-[#B2B2B2]',
            className
          )}
        />
      </div>
    );
  }
);

TextArea.displayName = 'TextArea';
